import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Atom } from "react-loading-indicators";

function GenerateBlog() {

  const [topic, setTopic] = useState('');
  const [topicKeywords, setTopicKeywords] = useState('');
  const [targetAudience, setTargetAudience] = useState('');
  const [brand, setBrand] = useState('FE International');
  const [geography, setGeography] = useState('Global');
  const [searchIntent, setSearchIntent] = useState('informational');
  const [supplementaryKeywords, setSupplementaryKeywords] = useState('');
  const [recipientEmail, setRecipientEmail] = useState('gaj.tanwar@feinternational.com');
  const [countries, setCountries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Styles (matching BulkEmails.js)
  const styles = {
    pageContainer: {
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '10vh',
    },
    appContainer: () => ({
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      maxWidth: '100%',
      padding: '10px',
    }),
    formContainer: () => ({
      width: '100%',
      maxWidth: '400px',
      transition: 'all 0.5s ease',
      padding: '20px',
    }),
    form: {
      display: 'flex',
      flexDirection: 'column',
    },
    headerText: {
      fontFamily: 'Arial, sans-serif',
      fontSize: '14px',
      marginTop: '10px',
      marginBottom: '20px',
      borderBottom: '1px solid black',
    },
    input: {
      margin: '5px 0',
      padding: '7px',
      borderRadius: '4px',
      border: '1px solid #cccccc',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
    },
    select: {
      margin: '5px 0',
      padding: '7px',
      borderRadius: '4px',
      border: '1px solid #cccccc',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      backgroundColor: 'white',
    },
    label: {
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      marginTop: '10px',
      marginBottom: '2px',
      fontWeight: 'bold',
    },
    button: {
      margin: '10px 0',
      padding: '10px',
      backgroundColor: '#6487dc',
      color: 'white',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '4px',
    },
  };

  // Fetch geography data on component mount
  useEffect(() => {
    axios.get('/api/fetch_geo_data_blog')
      .then((response) => {
        setCountries(response.data.countries || []);
      })
      .catch((error) => {
        console.error('Error fetching geography data:', error);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const payload = {
      topic: topic,
      topicKeywords: topicKeywords,
      targetAudience: targetAudience,
      brand: brand,
      geography: geography,
      searchIntent: searchIntent,
      supplementaryKeywords: supplementaryKeywords,
      recipientEmail: recipientEmail,
    };

    axios.post('/api/generate_blog', payload, {
      headers: { 'Content-Type': 'application/json' },
    })
    .then((response) => {
      setIsLoading(false);
      if (response.status === 200) {
        alert('Blog generated successfully. Please check your email.');
      }
    })
    .catch((error) => {
      setIsLoading(false);
      console.error('Error generating blog:', error);
      alert('Error generating blog. Please try again.');
    });
  };

  return (
    <div style={styles.appContainer()}>
      <div style={styles.formContainer()}>
        <form onSubmit={handleSubmit} style={styles.form}>
          <h3 style={styles.headerText}>Generate Blog</h3>

          <label style={styles.label}>Topic</label>
          <input
            type="text"
            placeholder="Enter blog topic"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            style={styles.input}
            required
          />

          
          <label style={styles.label}>Topic Keywords</label>
          <input
            type="text"
            placeholder="Enter comma separated topic keywords"
            value={topicKeywords}
            onChange={(e) => setTopicKeywords(e.target.value)}
            style={styles.input}
          />

          <label style={styles.label}>Target Audience</label>
          <input
            type="text"
            placeholder="Enter target audience"
            value={targetAudience}
            onChange={(e) => setTargetAudience(e.target.value)}
            style={styles.input}
            required
          />

          <label style={styles.label}>Brand</label>
          <select
            value={brand}
            onChange={(e) => setBrand(e.target.value)}
            style={styles.select}
            required
          >
            <option value="FE International">FE International</option>
            <option value="FE Capital">FE Capital</option>
          </select>

          <label style={styles.label}>Geography</label>
          <select
            value={geography}
            onChange={(e) => setGeography(e.target.value)}
            style={styles.select}
            required
          >
            {countries.map((country, index) => (
              <option key={index} value={country}>
                {country}
              </option>
            ))}
          </select>

          <label style={styles.label}>Search Intent</label>
          <select
            value={searchIntent}
            onChange={(e) => setSearchIntent(e.target.value)}
            style={styles.select}
            required
          >
            <option value="informational">Informational</option>
            <option value="commercial">Commercial</option>
            <option value="geography">Geography</option>
          </select>

          <label style={styles.label}>Supplementary Keywords</label>
          <textarea
            placeholder="Enter comma separated supplementary keywords"
            value={supplementaryKeywords}
            onChange={(e) => setSupplementaryKeywords(e.target.value)}
            style={{...styles.input, resize: 'vertical', minHeight: '60px'}}
          />

          <label style={styles.label}>Recipient Email</label>
          <select
            value={recipientEmail}
            onChange={(e) => setRecipientEmail(e.target.value)}
            style={styles.select}
            required
          >
            <option value="gaj.tanwar@feinternational.com">gaj.tanwar@feinternational.com</option>
            <option value="bhushan.chendekar@feinternational.com">bhushan.chendekar@feinternational.com</option>
            <option value="sumedh.kadam@feinternational.com">sumedh.kadam@feinternational.com</option>
          </select>

          {isLoading && (
            <div align="center" style={{ marginTop: '20px' }}>
              <Atom color="#32cd32" size="medium" text="Generating Blog..." />
            </div>
          )}

          <button type="submit" disabled={isLoading} style={styles.button}>
            Generate Blog
          </button>
        </form>
      </div>
    </div>
  );
}

export default GenerateBlog;

